import { css, cx } from '@eti/styles';
import Icon from '../icon/Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const styles = css`
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
`;
const lineStyles = (color, size) => css`
  height: ${size};

  &::after {
    border-top: calc(${size} / 4) solid ${color};
    content: '';
    left: 0;
    position: absolute;
    right: calc(${size} - 1px);
    top: 50%;
    transform: translateY(-50%);
  }
`;
const markStyles = size => css`
  position: relative;
  z-index: 1;

  & + & {
    margin-inline-start: calc(${size} / 2.35);
  }
`;
const arrowStyles = css`
  bottom: 0;
  position: absolute;
  right: 0;
  top: 0;
`;
const markIconStyles = css`
  display: block;
`;
const BoundIcon = _ref => {
  let {
    className,
    color,
    numberOfSegments = 1,
    size = '1rem',
    dataTestId
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: cx('etiBoundIcon', styles, className),
    "data-testid": dataTestId,
    children: [/*#__PURE__*/_jsx("div", {
      className: lineStyles(color, size)
    }), Array.from(Array(numberOfSegments).keys()).map(x => /*#__PURE__*/_jsx("div", {
      className: markStyles(size),
      children: /*#__PURE__*/_jsx(Icon, {
        className: markIconStyles,
        color: color,
        id: "bound-mark",
        size: size
      })
    }, x)), /*#__PURE__*/_jsx(Icon, {
      className: arrowStyles,
      color: color,
      id: "bound-arrow",
      size: size
    })]
  });
};
export default BoundIcon;
//# sourceMappingURL=BoundIcon.js.map